module.exports = __webpack_public_path__ + "assets/images/project/cross-icon.svg?v=185f67c4";